import React from 'react';

export default function CalSSO(salary, percentage, sso_paid) {
  if (percentage?.status) {
    const paid = sso_paid || 0;
    let total = salary * (percentage?.number / 100);

    if (total <= 0) return (0).toFixed(2);

    // สูงสุด: รวมกับที่จ่ายไปแล้วต้องไม่เกิน 875 บาท/เดือน
    if (total + paid > 875) {
      total = Math.max(0, 875 - paid);
    }

    // ต่ำสุด: รวมกับที่จ่ายไปแล้วต้องไม่น้อยกว่า 83 บาท/เดือน
    if (total + paid < 83) {
      total = Math.max(0, 83 - paid);
    }

    return total.toFixed(2);
  }
  return 0;
}
